import { render } from "./remainingSum.vue?vue&type=template&id=ab5a54f0&scoped=true"
import script from "./remainingSum.vue?vue&type=script&lang=js"
export * from "./remainingSum.vue?vue&type=script&lang=js"

import "./remainingSum.vue?vue&type=style&index=0&id=ab5a54f0&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5a54f0"]])

export default __exports__